import React from 'react';

export default function HomeProducts() {
  return (
    <section className="section product-band" id="products" aria-labelledby="products-title">
      <div className="section-heading">
        <p className="eyebrow dark">Products</p>
        <h2 id="products-title" className="dh-title-2">
          Products built for modern ownership and continuous corporate protection
        </h2>
      </div>
      <div className="product-grid">
        <article
          className="product-card"
          style={{ cursor: 'pointer' }}
          onClick={() => window.open('https://dplinvestone.com', '_blank')}
        >
          <div
            className="product-image investone"
            style={{ backgroundImage: 'url(/assets/investone-clear.png)' }}
          ></div>
          <div className="product-body">
            <p className="product-kicker">Fractional Ownership System</p>
            <h3 className="dh-title-3">InvestOne</h3>
            <p className="dh-text">
              A Fractional Ownership System that allows multiple investors to jointly own premium
              assets by investing smaller amounts and receiving returns based on their ownership share.
            </p>
            <a
              className="btn btn-secondary"
              href="https://dplinvestone.com"
              onClick={(e) => { e.preventDefault(); window.open('https://dplinvestone.com', '_blank'); }}
            >
              Discuss InvestOne
            </a>
          </div>
        </article>

        <article
          className="product-card"
          style={{ cursor: 'pointer' }}
          onClick={() => window.open('https://dpllexaudit.com', '_blank')}
        >
          <div
            className="product-image lexaudit"
            style={{ backgroundImage: 'url(/assets/lexaudit-clear.png)' }}
          ></div>
          <div className="product-body">
            <p className="product-kicker">Audit &amp; Legal Package</p>
            <h3 className="dh-title-3">LexAudit</h3>
            <p className="dh-text">
              A corporate service package combining Audit and Legal support for companies that need
              continuous compliance, documentation, advisory, and professional protection.
            </p>
            <a
              className="btn btn-secondary"
              href="https://dpllexaudit.com"
              onClick={(e) => { e.preventDefault(); window.open('https://dpllexaudit.com', '_blank'); }}
            >
              Explore LexAudit
            </a>
          </div>
        </article>
      </div>
    </section>
  );
}
